import { useQueryCallback } from '@tv2/lib-graphql';
import { UseQueryArgs } from '@tv2/lib-graphql/core';
import { useLeanProfile } from '../user/LeanProfileProvider';

export function useQueryCallbackWithProfile<Data = any, Variables = object>(
  args: UseQueryArgs<Variables, Data>
) {
  const { profile } = useLeanProfile().profile;

  const headers: Record<string, string> | undefined = profile?.profileToken
    ? {
        ...args.headers,
        'Client-Platform-User-Profile': profile.profileToken,
      }
    : args.headers;
  return useQueryCallback({ ...args, headers });
}
